import * as Normalize from '../normalize';
import * as Types from './types';

export const normalize = Normalize.normFn<Types.PanelObjSchema>(
  'panel',
  whole => whole
);

export const denormalize = Normalize.denormFn<Types.PanelObjSchema>(
  part => part
);
